import { createContext, useContext } from "react";

export type ToastTone = "success" | "info";

export type Toast = {
  id: string;
  message: string;
  tone: ToastTone;
};

export type ToastContextValue = {
  toasts: readonly Toast[];
  /**
   * Announce a routine success. `AGENTS.md` keeps toasts for routine successes
   * only: anything a person must act on is an inline message, a persistent
   * banner or a focus-managed dialog instead.
   */
  showToast: (message: string, tone?: ToastTone) => void;
  dismissToast: (id: string) => void;
};

export const ToastContext = createContext<ToastContextValue | null>(null);

export function useToast(): ToastContextValue {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within ToastProvider.");
  }
  return context;
}
